import {DEFAULT_ROW_COST} from "./coupon";

import type {GameType} from "@atg-sport-shared/pool-types/betTypes";

type CouponStakeBody = {
    betType: GameType;
};

type HarryStakeBody = {
    harry: true;
    betType: GameType;
};

export type PoolBetUnitStakeInput = CouponStakeBody | HarryStakeBody;

/**
 * Derives the unit stake for pool bet requests.
 * Unit stake is always the minimum row cost for the game type
 * (Big9: 50, SP5/SP96: 100), regardless of selected rowCost.
 */
export const getPoolBetUnitStake = (body: PoolBetUnitStakeInput): number =>
    DEFAULT_ROW_COST[body.betType];
